import { NgModule } from '@angular/core';
import { CardPreviewComponent } from './components/card-preview/card-preview.component';
import { CollectionsPageModule } from '../../collections-page/collections-page.module';

const components = [CardPreviewComponent];
@NgModule({
  declarations: components,
  imports: [CollectionsPageModule]
})
export class CardPreviewModule {}
